<template>
	<section id="localizacao" class="nosso-castelo" aria-label="Endereço">
		<h1 class="heading">Onde fica o nosso castelo</h1>
		<p>Estaremos de portas abertas para a nossa realeza.</p>
		<iframe
			src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d228.52838345808686!2d-46.64279227710372!3d-23.588040655302546!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1spt-BR!2sbr!4v1685561942515!5m2!1spt-BR!2sbr"
			width="100%"
			height="207.28"
			style="border: 0"
			title="Endereço Google Maps"
			allowfullscreen=""
			loading="lazy"
			referrerpolicy="no-referrer-when-downgrade"
		></iframe>
	</section>
</template>

<script>
export default {
	name: 'NossoCastelo'
};
</script>

<style></style>
